/**
 * Hook for setting the payment method on a checkout session
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { CheckoutResource } from '../../core/resources/checkout';
import { getGlobalApiClient } from './useApiQuery';
export function useSetPaymentMethod(options = {}) {
    const { sessionId, checkout, onSuccess } = options;
    const queryClient = useQueryClient();
    const checkoutResource = useMemo(() => new CheckoutResource(getGlobalApiClient()), []);
    const effectiveSessionId = sessionId ?? checkout?.checkoutSession?.id;
    const mutation = useMutation({
        mutationFn: (paymentMethodName) => {
            if (!effectiveSessionId) {
                throw new Error('No session ID available');
            }
            return checkoutResource.setPaymentMethod(effectiveSessionId, paymentMethodName);
        },
        onSuccess: async (_, paymentMethodName) => {
            await queryClient.invalidateQueries({ queryKey: ['checkout'] });
            onSuccess?.(paymentMethodName);
        },
    });
    const setPaymentMethod = async (paymentMethodName) => {
        await mutation.mutateAsync(paymentMethodName);
    };
    return {
        setPaymentMethod,
        isPending: mutation.isPending,
        error: mutation.error,
    };
}
